import gql from 'graphql-tag';

export const GetMe = gql`
    query getMe {
        getMe {
            ... on UserModelType {
                id
                email
                firstName
                lastName
                isActive
                isStaff
                website
                phoneNumber
                isVerified
                timeZone
                language
                isAgentCreated
                isSubscribed
                isAgentDelete
                isFinishedStepper
                key
                isAllowToStepper
                company {
                    id
                    name
                }
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
